import { useMemo } from "react";
import { useDistortionGrid } from "./DistortionGridContext";
import { useSvgViewBoxZoom } from "../../hooks/useSvgViewBoxZoom";

export function DistortionGridViewer() {
    const {
        svg,
        exportSvgString,
        cols,
        rows,
        vb,
        canExport,
        handleDownload,
    } = useDistortionGrid();

    const displayContent = useMemo(() => {
        if (!exportSvgString) return null;
        return exportSvgString.replace(/<\/?svg[^>]*>/gi, "").trim();
    }, [exportSvgString]);

    const base = useMemo(
        () => ({ x: 0, y: 0, w: cols * vb.width, h: rows * vb.height }),
        [cols, rows, vb.width, vb.height],
    );

    const {
        svgRef,
        viewBoxAttr: viewBox,
        panHandlers,
        zoomPercent,
        zoomIn,
        zoomOut,
        resetView,
    } = useSvgViewBoxZoom({ base });

    return (
        <div className="panel-viewer distortion-grid-viewer">
            <div className="path-tool-preview">
                <div className="svg-zoom-controls">
                    <button type="button" className="zoom-button" onClick={zoomOut} title="Zoom out">
                        −
                    </button>
                    <span className="zoom-level">{zoomPercent}%</span>
                    <button type="button" className="zoom-button" onClick={zoomIn} title="Zoom in">
                        +
                    </button>
                    <button type="button" className="zoom-button" onClick={resetView} title="Reset zoom">
                        ⌂
                    </button>
                    {canExport && (
                        <button type="button" className="zoom-button" onClick={handleDownload} title="Download SVG">
                            ↓
                        </button>
                    )}
                </div>

                <div className="svg-scroll-wrapper">
                    <div className="svg-container svg-container--fill distortion-grid-svg-container">
                        {displayContent ? (
                            <svg
                                ref={svgRef}
                                viewBox={viewBox}
                                xmlns="http://www.w3.org/2000/svg"
                                className="path-tool-svg distortion-grid-svg-host"
                                style={{ touchAction: "none" }}
                                {...panHandlers}
                                dangerouslySetInnerHTML={{ __html: displayContent }}
                            />
                        ) : (
                            <div className="svg-placeholder">
                                <p>Import an SVG to generate the distortion grid.</p>
                                <p className="svg-placeholder-hint">
                                    Each cell will show the artwork with progressively stronger
                                    path distortion, ordered left-to-right, top-to-bottom.
                                </p>
                            </div>
                        )}
                    </div>
                </div>
            </div>

            {svg && (
                <div className="path-tool-info">
                    <span>{cols} × {rows} cells — {cols * rows} variants</span>
                </div>
            )}
        </div>
    );
}
